
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Regulation from "../../components/Regulation/Regulation";
import MainButtons from "../../butttons/mainButtons/MainButtons";

export const RegulationPage = () => {

  return (
    <div >
      <Header/>
      <Regulation/>
      <MainButtons/>
      <Footer/>
    </div>

  );
};

